<template>
  <vue-easy-lightbox
    :visible="visible"
    :imgs="imgs"
    :index="index"
    @hide="handleHide"
  ></vue-easy-lightbox>
</template>

<script>
export default {
  name: 'LightBox',
  data () {
    return {
      visible: false,
      index: 0,
      imgs: [],
      unsubscribe: null
    }
  },
  mounted () {
    this.unsubscribe = this.$store.subscribeAction(action => {
      if (action.type === 'vEmit' && action.payload.name === 'openImage') {
        this.showImg(action.payload.data)
      }
    })
  },
  beforeDestroy () {
    this.unsubscribe()
  },
  methods: {
    showImg (img) {
      this.index = 0
      this.imgs = [img]
      this.visible = true
    },
    handleHide () {
      this.visible = false
    }
  }
}
</script>
